#@import Backbone
#@export DealCarousel.Media

window.DealCarousel ?= {}

DealCarousel.Media = Backbone.Model.extend

  initialize: ({@id, @type, @media, @thumb, @provider, @baseURL, @alt} = {}) ->
    @id ?= @cid

  isFeatured: ->
    @collection?.view.currentFeatured == this

  isLast: ->
    @collection?.last() == this
  
  isVideo: ->
    @type is "video"

